import { action, observable } from "mobx";
import makeApi, { URLS } from "Utils/apiURL";
import userDetail from "Stores/userDetail";
import DashboardState from "../mainState";

let cancelLinkedInInsights = null;

class LinkedInAutomationState {
  @observable filterPayload = {
    value: "7d",
    days: 7,
    filterFromDate: "",
    filterToDate: ""
  };
  @observable linkedInInsightData = null;
  @observable linkedInInsightLoader = true;
  @observable activeLinkedInInsightTab = "7d";

  @action
  setFilterPayload = value => {
    this.filterPayload = value;
  };

  @action
  setLinkedInInsightLoader = value => {
    this.linkedInInsightLoader = value;
  };

  @action
  setActiveLinkedInInsightTab = value => {
    this.activeLinkedInInsightTab = value;
  };

  @action
  getLinkedInAnalyticsData = async (data = {}) => {
    try {
      const { memberId = "", team = false } = userDetail?.userInfo || {};
      if (DashboardState?.memberId?.length > 0) {
        data.memberIds = DashboardState.memberId;
      } else {
        if (!team) {
          data.memberIds = [memberId];
        }
      }
      const config = {
        url: URLS.getLinkedInActivityInsights,
        method: "POST",
        data
      };

      if (cancelLinkedInInsights !== null) {
        cancelLinkedInInsights("cancel");
        cancelLinkedInInsights = null;
      }
      const cancelReqCallback = value => {
        cancelLinkedInInsights = value;
      };
      let res = await makeApi(config, cancelReqCallback);
      if (res?.data && Object.keys(res?.data).length > 0) {
        this.linkedInInsightData = res?.data;
      } else {
        this.linkedInInsightData = !res?.message ? [] : null;
      }
    } catch (err) {
      console.error("Get LinkedIn Report Error", err);
    }
  };
}

const linkedInAutomationState = new LinkedInAutomationState();
export { linkedInAutomationState };
export default linkedInAutomationState;
